<template>
    <div class="met-index-wrap">
        <MtTitle title="公司简介" :size="7" english="INTRODUCE" type="blue"></MtTitle>
        <div class="company-box">
            <div class="text-section">上海勤联物联网有限公司简称勤联科技，英文名Shanghai Qlian I.O.T Co.Ltd ，注册地徐汇区，注册资本1176万元，是上海市高新技术企业拥有ICP、人力资源许可证、互联网食品销售许可证、软件企业、软件产品等证书，累计服务超过1000万会员！业务涵盖APP、微信端和支付宝端。</div>
            <br>
            <!-- <div class="text-section">截止目前拥有37个软件著作权、15个商标，2020年通过企业知识产权管理体系认证（GB/T29490-2013）,是一家专注研发创新和注重知识产权的公司！同时主动协助客户获得了数十个软件著作权！</div> -->
            <!-- <img class="company-img" data-src="../../static/mt_img/aptitude-img.png" alt=""> -->
        </div>
        <div class="channels-box">
            <img class="channels-img" data-src="../../static/mt_img/channels-img.png" alt="">
            <div class="channels-text">
                公司业务包含安卓APP（小米、华为、腾讯应用宝、OPPO、VIVO、360等十几家渠道）、苹果IOS APP、微信、支付宝、UC浏览器APP/夸克APP等渠道累计服务尽<span>2000万网民</span>，日活<span>30万用户</span>左右
            </div>
        </div>
        <MtTitle title="赋能数字化" :size="6" english="ENABLING DIGITIZATION" type="blue"></MtTitle>
        <img class="process-img" data-src="../../static/mt_img/process-img.png" alt="">
        <div class="question">什么是数字化转型</div>
        <div class="answer">数字化转型：DT（Digital Transformation），利用数字化技术进行第2版的Transformation，帮助线下商户和实体门店在支付经营过程中，充分利用微信和支付宝内流量和营销能力，提升商户的营销效率，从而带动商户GMV的增长。</div>
        <div class="partner-box">
            <div class="partner-title">
                <MtTitle title="合作伙伴" :size="6" english="COOPERATIVE PARTNER" type="blue"></MtTitle>
            </div>
            <img data-src="../../static/mt_img/partners.png" alt="">
        </div>
        <MtTitle title="勤联科技创始人" :size="7.5" english="FOUNDER" type="blue"></MtTitle>
      <div class="teamText">{{teamText}}</div>
      <!-- <img class="teamMt" :data-src="teamMt" alt=""> -->
<!--        <div class="founders-img">-->
<!--            <div class="founder-item" v-for="(item,index) in founders" :key="index">-->
<!--                <img :data-src="item.img" alt="">-->
<!--                <div class="founder-info">{{item.text}}</div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>
<script>
import MtTitle from '../components/Mt-title'
export default {
    name: "mt-index",
    components: {
        MtTitle
    },
    data(){
        return {
          teamMt: require('../../static/teamMt.png'),
          teamText: '公司创始团队毕业于清华大学、中欧国际工商学院等名校，拥有成功连续创业经验，愿景是将运动健康和社交电商结合希望看到更多的客户生活更健康美好！',
            founders: [
                {
                    img: require('../../static/mt_img/founder1.png'),
                    text: '周俊，本科毕业于郑州大学金融数学专业，2017年毕业于浙江大学金融学硕士，毕业后一直在VC创投任职，担任杭州万豪投资管理有限公司投资总监，成功投资IT互联网、新零售领域等多家企业并退出，目前担任上海勤联物联网有限公司董事长'
                },
                {
                    img: require('../../static/mt_img/founder2.png'),
                    text: '朱慧觉，中国民主建国会会员，2017年毕业于中欧国际工商学院工商管理硕士，清华大学经济管理学院研究生在读，连续创业者，2005年进入互联网行业从事技术研发、管理和产品运营工作，目前担任上海勤联物联网有限公司总经理 '
                },
                {
                    img: require('../../static/mt_img/founder3.png'),
                    text: '高玮琨，中国民主建国会，毕业于华东师范大学计算机本科，是互联网连续创业者，沉浸互联网行业15年，参与过多个千万级用户量级的移动APP项目研发和运营！目前担任上海勤联物联网有限公司总裁'
                }
            ]
        }
    },
    created(){
        localStorage.setItem('path','./mt_tab')
        localStorage.setItem('index',0)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
.company-box{
    width: 90vw;
    margin: 0 auto;
    font-size: 3.2vw;
    color: #2B2E48;
    line-height: 7vw;
}
.teamMt{
  width: 100vw;
}
.teamText{
  width: 95vw;
  margin: 0 auto 5vw;
  text-align: center;
  font-size: 3vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 5.24vw;
}
.text-section{
    text-indent:2em;
}
.company-img{
    width: 100%;
    margin-top: 7vw;
    margin-bottom: 7vw;
}
.channels-box{
    width: 100%;
    position: relative;
}
.channels-img{
    width: 100%;
}
.channels-text{
    position: absolute;
    width: 92vw;
    padding: 0 4vw;
    bottom: 10vw;
    left: 0;
    font-size: 3.2vw;
    color: #fff;
    line-height: 3.92vw;
}
.channels-text > span{
    color: #FFFAAA;
}
.process-img,.question,.answer{
    width: 88vw;
    margin-left: 6vw;
}
.question{
    font-size: 3.2vw;
    font-weight: bold;
    line-height: 6.24vw;
    margin-top: 9vw;
}
.answer{
    font-size: 3.2vw;
    line-height: 6.24vw;
}
.partner-box{
    width: 100%;
    margin-top: 7vw;
    position: relative;
}
.partner-box > img{
    width: 100%;
}
.partner-title{
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}
.founders-img{
    width: 92vw;
    margin-left: 4vw;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10vw;
}
.founder-item{
    width: 29vw;
    position: relative;
}
.founder-item > img{
    width: 29vw;
}
.founder-info{
    position: absolute;
    width: 25vw;
    left: 2vw;
    bottom: 3vw;
    font-size: 2.4vw;
    color: #fff;
    line-height: 3.63vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/mt_index.vue